import React from "react";
import numeral from "numeral";

import classes from "./Watch.module.css";

export default function SubscribeBtn(props) {
  return (
    <button className={classes.SubscribeBtn}>
      Subscriber
      {props.subscribers > 1 ? "s" : ""}
      <span>{numeral(props.subscribers).format("0.a")}</span>
    </button>
  );
}
